import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import {
  catchError,
  distinctUntilChanged,
  filter,
  map,
  switchMap
} from 'rxjs/operators';
import { StateFacade as OverviewFacade } from '../../facades/state.facade';
import { CommonRequest } from '../../models/api/tracker.interfaces';
import { SnapshotService } from '../../services/api/snapshot.service';
import * as OverviewActions from '../actions/api.actions';

@Injectable()
export class SnapshotEffects {
  loadSnapshotData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OverviewActions.loadSnapshot),
      switchMap(() =>
        this.overview.flags$.pipe(
          filter((flag) => !!flag?.snapshot),
          switchMap(() =>
            this.overview.serviceConfiguration$.pipe(
              distinctUntilChanged(
                (previous, current) =>
                  JSON.stringify(previous) === JSON.stringify(current)
              ),
              switchMap((payload: CommonRequest) =>
                this.snapshot.getSnapshot(payload).pipe(
                  map((content) =>
                    OverviewActions.loadSnapshotSuccess({
                      snapshot: {
                        id: 'snapshot-content',
                        snapshotData: content
                      }
                    })
                  ),
                  catchError(() =>
                    of(
                      OverviewActions.loadSnapshotFailure({
                        error: {
                          id: 'snapshot-content-error',
                          snapshotDataError: 'snapshot'
                        }
                      })
                    )
                  )
                )
              )
            )
          )
        )
      )
    )
  );

  constructor(
    private readonly actions$: Actions,
    private readonly snapshot: SnapshotService,
    private readonly overview: OverviewFacade
  ) {}
}
